import { Link } from 'react-router';
import { useMemo } from 'react';
import { useEnterpriseOrg } from '../../context/EnterpriseOrgContext';
import { clearEnterpriseAccessSession } from '../EnterpriseAccessRoute';
import { useAdminRole } from '../../lib/use-admin-role';

/**
 * Workspace chrome for authenticated `/enterprise` routes: active org, theme, session controls.
 * Section links (Overview, Solutions, …) live only in `EnterpriseSalesNav` — do not duplicate here.
 */
export function EnterpriseTopbarBadge() {
  const { activeMembership, activeOrgId, setActiveOrgId } = useEnterpriseOrg();
  const { isAdmin, loading: adminRoleLoading } = useAdminRole();

  const orgName = activeMembership?.organizations?.name || 'No active workspace';
  const role = activeMembership?.role || 'no role';
  const status = activeMembership?.status || 'inactive';
  const statusLabel = useMemo(() => status.toLowerCase(), [status]);

  return (
    <div className="enterprise-topbar-badge relative z-40 border-b border-slate-800/80 bg-slate-950/95 shadow-[0_10px_30px_-20px_rgba(37,99,235,0.8)] backdrop-blur">
      <div className="mx-auto flex w-full max-w-6xl flex-wrap items-center justify-between gap-3 px-4 py-3">
        <div className="flex min-w-0 items-center gap-3">
          <span className="rounded-md bg-gradient-to-r from-blue-700 to-slate-700 px-2.5 py-1 text-[11px] font-semibold uppercase tracking-wide text-white">
            Enterprise
          </span>
          <div className="min-w-0">
            <p className="truncate text-sm font-semibold text-slate-100">{orgName}</p>
            <p className="text-[11px] uppercase tracking-wide text-slate-300">
              {role} · {statusLabel}
            </p>
          </div>
        </div>

        <div className="flex flex-wrap items-center justify-end gap-2">
          {!adminRoleLoading && isAdmin ? (
            <Link
              to="/enterprise/admin"
              className="rounded-md border border-blue-700/50 bg-blue-950/40 px-2.5 py-1 text-xs font-medium text-blue-100 transition-colors hover:bg-blue-900/50"
            >
              Command Center
            </Link>
          ) : null}
          <button
            type="button"
            className="rounded-md border border-slate-700 bg-slate-900 px-2.5 py-1 text-xs text-slate-200 hover:bg-slate-800"
            onClick={() => setActiveOrgId(null)}
            disabled={!activeOrgId}
          >
            Clear org
          </button>
          <button
            type="button"
            className="rounded-md border border-slate-700 bg-slate-900 px-2.5 py-1 text-xs text-slate-200 hover:bg-slate-800"
            onClick={() => {
              void clearEnterpriseAccessSession();
              window.location.reload();
            }}
          >
            Lock
          </button>
        </div>
      </div>
    </div>
  );
}
